<div class="search-container">
  @if(heading && subHeading){
  <div class="search-title-content">
    <p class="miniheading">{{ subHeading }}</p>
    <h2 class="heading">{{ heading }}</h2>
  </div>
  }
  <div class="search-content">
    <div class="search-bar" [style]="'background : '+backgroundColor+'; '+maxWidth">
      <div class="search-bar-input" *ngIf="displayKeywordInput">
        @if(showSearchIconLeft){
        <img [src]="sharedService.imagesUrl + 'search-icon.svg'" width="25" height="24" class="search-icon-styling"
          alt="" />
        }
        <input class="input-styling" placeholder="{{ keywordplaceholder }}" (keyup)="searchInput($event)"
          [(ngModel)]="sharedService.pharmacyInput" [style]="'background : '+backgroundColor" />
      </div>
      <div class="zip-search-bar-input search-bar-input-zipcode">
        <img *ngIf="!displayKeywordInput" [src]="sharedService.imagesUrl + 'search-icon.png'" width="25" height="24"
          class="search-icon-styling" alt="" />
        <img *ngIf="displayKeywordInput" [src]="sharedService.imagesUrl + locationIcon" width="25" height="24"
          class="search-icon-styling" alt="" />
        <div class="auto-resize-input-container"
          [attr.data-value]="sharedService.pharmacyInfo?.zipCode ? sharedService.pharmacyInfo.zipCode : zipCodePlaceholder">
          <input class="input-styling zipCode-input" [placeholder]="zipCodePlaceholder"  (input)="onNumberInput($event)"
            (keyup)="onZipCodeChange($event)" maxlength="5" [(ngModel)]="sharedService.pharmacyInfo.zipCode"
            [style]="'background : '+backgroundColor" />
        </div>
        <button class="search-btn" [disabled]="isLoading" (click)="onSearch()">
          @if(isLoading) {
          <div class="spinner-border" role="status"></div>
          }
          @if(showSearchIconRight){
          <img [src]="sharedService.imagesUrl + 'seach-icon-btn.png'" alt="" />
          }
          @if(showSearchText){
            <span class="search-txt">{{ "SEARCH_COMPONENT.BUTTON" | translate }}</span>
          }
        </button>
      </div>

    </div>
    <!-- <p class="medicine"> -->
    <p *ngIf="medicine" class="medicine">{{ medicine }}
      <span>{{ search1 }} </span> <span>{{ search2 }} </span> <span>{{ search3 }} </span>
    </p>
    @if(!noData && (search || (showResultsOnZip && zipCode))){
    <!-- This is the part where we show the listing -->
    <ng-content></ng-content>
    }
    <!-- Error line sits just below the field (small gap) and above the not-found template -->
    <ng-content select=".search-error"></ng-content>
    <!-- <div class="search-bar-input search-bar-input-zipcode"> 
      <img *ngIf="!displayKeywordInput" [src]="sharedService.imagesUrl + 'search-icon.png'" width="25" height="24" class="search-icon-styling" alt="" />
      <img *ngIf="displayKeywordInput" [src]="sharedService.imagesUrl + 'icons/location-vector.svg'" width="25" height="24" class="search-icon-styling" alt="" />
      <input class="input-styling" [(ngModel)]="search" placeholder="48243" maxlength="5" />
    </div>
    <button (click)="onSearch()" class="search-btn">
      <img [src]="sharedService.imagesUrl + 'seach-icon-btn.png'" alt="" />
      {{"SEARCH_COMPONENT.BUTTON" | translate }}
    </button> -->
  </div>
  @if(noData&& !isLoading&&search.length>=4 && notFoundKeyword){
  <div class="search-no-results">
    <img [src]="sharedService.imagesUrl + 'search-unhappy.png'" alt="" />
    <div class="search-result-text">
      <p class="result-error-description">
        {{"SEARCH_COMPONENT.INFO" | translate }}
        <span>'{{ notFoundKeyword }}'</span>
        .
      </p>
      <p class="result-error-suggestion">{{"SEARCH_COMPONENT.HELPTEXT" | translate }}</p>
    </div>
  </div>
  }
</div>